export default __webpack_public_path__ + "locales/az/Ldap.json?hash=dfb1a7400dddaa6f5184a71aca89fcaa";